var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"items-per-page":15,"hide-default-footer":"","item-key":"date"},scopedSlots:_vm._u([{key:"item.date",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm._f("formatDate")(item.date)))]}},{key:"item.adultPrice",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item.adultPrice)+" "+_vm._s(item.currency))]}},{key:"item.childPrice",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item.childPrice)+" "+_vm._s(item.currency))]}},{key:"item.infantPrice",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item.infantPrice)+" "+_vm._s(item.currency))]}},{key:"item.itemPrice",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item.itemPrice)+" "+_vm._s(item.currency))]}},{key:"item.remaining",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item.isOnRequest ? "On request" : item.remaining))]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11025934","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gt/itineraries/builder/ItineraryBuilderItemQuickAddItemPricesGrid.vue
// module id = null
// module chunks = 